module.exports = "/assets/career/team/marta_wysocka.png?U96X2+x";